import { Utility } from 'src/app/shared/utility';
import { AfterViewInit, Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../shared/services/auth/auth.service';
import { DBkeys } from '../shared/services/auth/db-keys';
import { ReadConfigService } from '../shared/services/common/read-config.service';
import { MessagesService } from '../shared/services/messages/messages.service';
import { UsersService } from '../shared/services/common/users.service';
import { HttpErrorResponse } from '@angular/common/http';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})

export class HeaderComponent implements OnInit, AfterViewInit {
  isMobileMenu = false;
  @Input() currentTab: any;
  @Output() selectedOrganization = new EventEmitter();
  links = [];
  subLinks = {};
  menuItems = [];
  subTasks: any;
  disableOrgChange = false;
  orgCount = 0;
  claims: any;
  currPerm: any[];
  showAccountTab: boolean;
  multiOrg: boolean;
  hideOrgPopup = true;
  manual: boolean;
  isRefreshed: boolean;
  unreadMsgCount = 0;
  showMsgDialog: boolean;
  messageBody: string;
  minutes: number;
  inputData: { userInfo: any; };
  showNavigation = true;
  currentStage: any;
  showNotification: boolean;
  omessageBody: any;
  theOtherUploads = false;
  @HostListener('window:load')
  unloadHandler() {
    this.isRefreshed = true;
  }

  constructor(
    private router: Router,
    private authService: AuthService,
    private usersService: UsersService,
    private messagesService: MessagesService,
    public readConfigService: ReadConfigService) { }

  ngOnInit() {
    this.menuItems = this.readConfigService.getMenuItems();
    this.subTasks = this.readConfigService.getSubTasks();
    this.currentStage = this.readConfigService.getCurrentStage();
    this.getOrgCount();
    const paths = location.pathname.replace(/\//g, ',').split(',');
    this.showNavigation = paths.length > 1 && paths[1].toLowerCase() !== 'forbidden';
  }

  ngAfterViewInit(): void {
    this.authService.isInEditMode$().forEach(message => { this.disableOrgChange = !message; });
  }

  getOrgCount() {
    setTimeout(() => {
      const orgCount = sessionStorage.getItem(DBkeys.ORG_CNT);
      if (orgCount !== null) {
        if (orgCount !== '0') {
          this.multiOrg = parseInt(orgCount, 0) > 1;
          this.hideOrgPopup = this.isRefreshed;
          this.isRefreshed = false;
          this.selectedOrganization.emit(this.authService.getInitialOrg());
          this.getTopNavMenu();
        } else {
          this.router.navigate(['/forbidden']);
          this.showNavigation = false;
        }
      } else {
        this.getOrgCount();
      }
    }, 500);
  }

  getUnreadMsgCount() {
    this.messagesService.getUnreadMessageCount(this.inputData).subscribe((data: any) => {
      if (data && data.statusCode === 200) {
        this.unreadMsgCount = data.result;
        this.messagesService.setMsgCount(this.unreadMsgCount.toString());
        this.setUnreadMsgCount();
      }
    },
      (err: HttpErrorResponse) => {
        if (sessionStorage.getItem('unreadMsgCount') !== null) {
          console.log(err.error);
        }
      });
  }

  getOutageNotif() {
    const outageDetails = this.readConfigService.getOutageScheduledDetails();
    const outageConfig = this.readConfigService.getOutageText();
    if (outageDetails && !outageDetails.maintenanceFlag && sessionStorage.getItem('showOutageNotif') === null) {
      this.showNotification = true;
      const datePipe = new DatePipe('en-US');
      this.omessageBody = outageConfig.Notification.replace('{0}', datePipe.transform(outageDetails.startDt, 'EEEE, MMMM d, y, h:mm a'));
      this.omessageBody = this.omessageBody.replace('{1}', datePipe.transform(outageDetails.endDt, 'EEEE, MMMM d, y, h:mm a'));
    }
  }

  closeOutage() {
    this.showNotification = false;
    sessionStorage.setItem('showOutageNotif', 'true');
  }

  setUnreadMsgCount() {
    setTimeout(() => {
      this.getUnreadMsgCount();
    }, (this.minutes * 60000));
  }

  /**
   * @description
   * Function to set padding for messages number
   */
  setPaddingClass() {
    let paddingClass = '';
    if (this.unreadMsgCount < 11) {
      paddingClass = 'num-padding-single';
    } else {
      paddingClass = 'num-padding-double';
    }
    return paddingClass;
  }

  getTopNavMenu() {
    setTimeout(() => {
      if (sessionStorage.getItem('DFLoaded') === 'true') {
        this.links = [];
        this.subLinks = [];
        this.usersService.setLoginTime();
        this.theOtherUploads = !this.authService.getDarkKeyValue('Uploads');
        this.menuItems.forEach((element: any) => {
          // remove member related tasks which were previously under documents for the uploads dropdown menu
          if (this.theOtherUploads && element === 'Documents') {
            this.subTasks[element] = null;
          }
          if ((this.subTasks[element] && element !== 'Uploads') || (this.theOtherUploads && element === 'Uploads')) {
            const arr = [];
            this.subTasks[element].forEach((ele: any) => {
              if (this.authService.getDarkKeyValue(ele)) {
                arr.push(ele);
              }
            });
            if (arr.length > 0) {
              const obj = {};
              obj[element] = arr;
              this.subLinks[element] = arr;
              this.links.push(element);
            }
          } else {
            if ((element === 'Home' && this.authService.getDarkKeyValue('Home')) ||
              (element === 'Pay Schedule' && this.authService.getDarkKeyValue('Pay Schedule')) ||
              (element === 'Invoice' && this.authService.getDarkKeyValue('Invoice')) ||
              (element === 'Uploads' && this.authService.getDarkKeyValue('Uploads') && !this.theOtherUploads) ||
              (element === 'Employer Documents' && this.theOtherUploads && this.authService.getDarkKeyValue('Employer Documents')) ||
              (element === 'Help' && this.authService.getDarkKeyValue('Help'))) {
              this.links.push(element);
            }
          }
        });
        if (this.authService.getDarkKeyValue('Messages')) {
          this.inputData = { userInfo: this.usersService.UserInfo() };
          this.minutes = this.readConfigService.getSecuMessagesText().MessageTimeoutMin;
          if (sessionStorage.getItem('unreadMsgCount') !== null) {
            this.unreadMsgCount = JSON.parse(sessionStorage.getItem('unreadMsgCount'));
            this.setUnreadMsgCount();
          } else {
            this.getUnreadMsgCount();
          }
          this.messagesService.collection$.subscribe(response => {
            this.unreadMsgCount = response;
          });
          this.messagesService.setMsgCount(this.unreadMsgCount.toString());
        }
        this.showAccountTab = this.authService.getDarkKeyValue('Account');
        if (this.readConfigService.getDarkFeatureFlag(this.readConfigService.getOutageDFName())) {
          this.getOutageNotif();
        }
      }
    }, 500);
  }

  /**
   * @description
   * Function to control mobile menu show and hide
   */
  showMobileMenu() {
    window.scrollTo(0, 0);
    const appFooter = document.getElementById('app-footer');
    const middleContent = document.getElementById('middle-content');
    if (appFooter !== null && middleContent !== null) {
      if (!this.isMobileMenu) {
        this.isMobileMenu = true;
        appFooter.classList.add('conditional-display');
        middleContent.classList.add('conditional-display');
      } else {
        this.isMobileMenu = false;
        appFooter.classList.remove('conditional-display');
        middleContent.classList.remove('conditional-display');
      }
    }
  }

  /**
   * @description
   * Function to set class for mobile hamburger icon
   */
  setClass() {
    let retClass: any;
    if (this.isMobileMenu) {
      retClass = 'close';
    }
    return retClass;
  }

  /**
   * @description
   * Function to toggle class for active route
   */
  setActiveClass(link: string) {
    const paths = location.pathname.replace(/\//g, ',').split(',');
    return paths.length > 1 && this.replaceSpace(link).toLocaleLowerCase() === paths[1] ? 'text-red' : 'text-black';
  }

  setChildActiveClass(parent: any, child: any, isMobile: boolean) {
    child = this.replaceSpace(this.updatedLink(child));
    const paths = location.pathname.replace(/\//g, ',').split(',');
    return paths.length > 1 && location.pathname === `/${parent}/${child}`.toLowerCase() ?
      isMobile ? 'text-red' : 'background-red' : 'text-black';
  }

  displayIcon(parent: string) {
    const value = this.subLinks[parent];
    return value && value.length > 0;
  }

  getChildLinks(parent: any, isMobile: boolean) {
    const value = this.subLinks[parent];
    let childLinks = value && value.length > 0 ? value : [];
    if (isMobile && parent === 'Documents') {
      childLinks = childLinks.filter((s: any) => s !== 'Member Document Upload');
    }
    return childLinks;
  }

  parentRouterLink(parent: any, isMobile: boolean) {
    if (this.getChildLinks(parent, isMobile).length === 0) {
      const link = this.replaceSpace(parent);
      this.router.navigate([link]);
      this.showMobileMenu();
    }
  }

  getRouterLink(parent: any, link: any): any {
    if (parent !== 'Account') {
      link = this.updatedLink(link);
      this.showMobileMenu();
      this.router.navigate(['/' + parent.toLowerCase() + '/' + this.replaceSpace(link)]);
    }
  }

  updatedLink(link: any) {
    if (link.indexOf('(') > 1) {
      link = link.substring(0, link.indexOf('(')).trim();
    } else if (link.indexOf('/') > 1) {
      link = link.substring(0, link.indexOf('/')).trim();
    }
    return link;
  }

  replaceSpace(link: any) {
    return Utility.lowerString(link).replace(/ /g, '-');
  }

  close() {
    this.hideOrgPopup = true;
    this.manual = false;
  }

  orgValue(args: any) {
    if (args) {
      this.selectedOrganization.emit(args.orgName);
      this.getTopNavMenu();
    }
  }

  // if we need user permissions on refresh
  // 1. uncomment the code
  // 2. Use userinfo in API
  // getUserPermissions() {
  //   if (this.currentOrg) {
  //     this.accountService.getPermissionsEndpoint()
  //       .subscribe(claims => {
  //         this.claims = claims.result;
  //         this.currPerm = this.claims;
  //         this.authService.saveCurrentPermissions(this.claims);
  //         // this.authService.getDarkFeatureValue();
  //         this.getTopNavMenu();
  //       });
  //     }
  // }

  logout() {
    this.hideOrgPopup = true;
    sessionStorage.setItem('logout', 'true');
    this.authService.logout(true);
    this.authService.redirectLogoutUser();
  }

  selectOrg() {
    this.isRefreshed = false;
    this.hideOrgPopup = false;
    this.manual = true;
  }
}
